<template>
  <div class="c-foot xy-center">
    <div class="contact-icon">
      <el-tooltip class="item" effect="dark" content="商城网站" placement="top-start">
        <el-button class="item-icon icon-1"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="微信" placement="top-start">
        <el-button class="item-icon icon-2"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="QQ" placement="top-start">
        <el-button class="item-icon icon-3"></el-button>
      </el-tooltip>
    </div>
    <div class="qr-code x-center">
      <!-- <div class="xy-center">
                <img src="./../../../public/images/public/qrcode.png">
                <span>公众号</span>
            </div>
            <div class="xy-center">
                <img src="./../../../public/images/public/qrcode.png">
                <span>个人号</span>
            </div> -->
    </div>
    <div class="detail">
      <!-- <span>ICP备20211009号</span> -->
      <span>Copyright© 2021  {{ apiUrl }}. 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index"
          style="color: rgb(23 139 225);margin-left:10px;">{{ beian }}</a></span>
      <span>Powered by {{ apiUrl }} 1.0.1 服务热线：400-8658-777</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CFoot",
  data() {
    return {
      apiUrl: ""
    };
  },
  mounted() {
    this.apiUrl = myconfig.title;
    this.beian = myconfig.beian;
  }
};
</script>

<style scoped lang="scss">
.c-foot {
  width: 100%;
  background: #fff;
  flex-direction: column;
  padding: 18px 0;

  .contact-icon {
    .item-icon {
      width: 31px;
      height: 31px;
      border: none;
      outline: none;
      border-radius: 50%;
      margin: 0 10px;
    }

    .icon-1 {
      background: url("./../../../public/images/public/taohua1.jpg") center no-repeat;
    }

    .icon-2 {
      background: url("./../../../public/images/public/wx.png") center no-repeat;
    }

    .icon-3 {
      background: url("./../../../public/images/public/qq.png") center no-repeat;
    }
  }

  .qr-code {
    padding: {
      top: 30px;
      bottom: 26px;
    }

    .xy-center {
      flex-direction: column;
      padding: 0 23px;

      img {
        width: 75px;
        height: 75px;
      }

      span {
        margin-top: 10px;
      }
    }
  }

  .detail {
    text-align: center;

    a {
      color: rgb(23 139 225);
    }

    span {
      display: block;
      font-family: Source Han Sans CN;
      color: rgba(102, 102, 102, 1);
      font-size: 18px;

      margin: {
        bottom: 15px;
      }
    }

    /*span:nth-child(1) {*/
    /*  font-size: 22px;*/
    /*  font-weight: bold;*/
    /*  color:rgba(51,51,51,1);*/
    /*  margin: {*/
    /*    top: 26px;*/
    /*    bottom: 22px;*/
    /*  }*/
    /*}*/

    span:nth-child(5),
    span:nth-child(6) {
      color: rgba(153, 153, 153, 1);
    }

    span:nth-child(5) {
      margin-top: 29px;
    }
  }
}
</style>
